export default __webpack_public_path__ + "static/media/done.d79dcc3b.svg";